<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11QAYXY/tc-custom/9780802194459.jpg?1718044185272" alt="This image is the cover for the book Sarah Thornhill"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sarah Thornhill
      </h1>
      <p class="bookDescription body article font2">
        <b>The Orange Prize–Winning author of <i>The Secret River</i> delivers “brilliant fiction and illuminating personal history” in the finale of her Australian trilogy (<i>The Independent</i>).</b><br/>  <br/> With <i>The Secret River</i>, Kate Grenville dug into her own family’s history to create an unflinching tale of frontier violence in early Australia. She continued her bold exploration of Australia’s beginnings in <i>The Lieutenant</i>. Now <i>Sarah Thornhill</i> brings this acclaimed trilogy to an emotionally explosive conclusion.<br/>  <br/> Sarah is the youngest daughter of William Thornhill, an ex-convict from London. Unknown to Sarah, her father has built his fortune on the blood of Aboriginal people. With a fine stone house and plenty of money, Thornhill has reinvented himself, teaching his daughter to never look back or ask about the past. Instead, Sarah fixes her eyes on handsome Jack Langland, whom she’s loved since she was a child. Their romance seems idyllic, but the ugly secret in Sarah’s family is poised to ambush them both.<br/>  <br/> Driven by the captivating voice of the illiterate Sarah—at once headstrong, sympathetic, curious, and refreshingly honest—this is an unforgettable portrait of a passionate woman caught up in a historical moment that’s left an indelible mark on the present.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kate Grenville
      </h2>
      
      <p class="authorDescription body article">Kate Grenville&#39;s works of fiction include <I>The Secret River</I>, winner of the Commonwealth Writers&#39; Prize for Best Book and short listed for the Man Booker Prize, and <I>The Idea of Perfection</I>, winner of the Orange Prize for Fiction. She lives in Sydney.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Text Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f3419562